import React, { createContext, useState, useContext, useEffect } from "react";
import api, { setAuthTokenInHeader } from "../config/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const getTokenFromStorage = () => localStorage.getItem("authToken") || null;
  const getUserIdFromStorage = () => localStorage.getItem("userId") || null;
  const getUsernameFromStorage = () => localStorage.getItem("username") || null;
  const getIsFirstLoginFromStorage = () => localStorage.getItem("isFirstLogin") || null;

  const [token, setAuthToken] = useState(getTokenFromStorage());
  const [userId, setUserId] = useState(getUserIdFromStorage());
  const [username, setUsername] = useState(getUsernameFromStorage());
  const [isFirstLogin, setIsFirstLogin] = useState(getIsFirstLoginFromStorage());

  const setAuthData = (token, userId, username, isFirstLogin) => {
    setAuthToken(token);
    setUserId(userId);
    setUsername(username);
    setIsFirstLogin(isFirstLogin);

    localStorage.setItem("authToken", token);
    localStorage.setItem("userId", userId);
    localStorage.setItem("username", username);
    localStorage.setItem("isFirstLogin", isFirstLogin);
  };

  const logout = () => {
    setAuthToken(null);
    setUserId(null);
    setUsername(null);
    setIsFirstLogin(null);

    localStorage.removeItem("authToken");
    localStorage.removeItem("userId");
    localStorage.removeItem("username");
    localStorage.removeItem("isFirstLogin");
  };

  // Effect to monitor changes in localStorage
  useEffect(() => {
    const syncStateWithStorage = () => {
      setAuthToken(getTokenFromStorage());
      setUserId(getUserIdFromStorage());
      setUsername(getUsernameFromStorage());
      setIsFirstLogin(getIsFirstLoginFromStorage());
    };

    syncStateWithStorage();

    window.addEventListener('storage', syncStateWithStorage);

    return () => {
      window.removeEventListener('storage', syncStateWithStorage);
    };
  }, []);

  useEffect(() => {
    if (token) {
      setAuthTokenInHeader(token);
    }
  }, [token]);

  const refreshUser = async () => {
    const response = await api.get(`${process.env.REACT_APP_API_URL}/api/users/${userId}`);
    const user = response.data;
    setIsFirstLogin(user.is_first_login);

    localStorage.setItem("isFirstLogin", user.is_first_login);
  };

  return (
    <AuthContext.Provider value={{ token, userId, username, isFirstLogin, setAuthData, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
